#import "./AddressFull.graphql"
#import "./CompanyFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"

fragment B2bCustomerFull on B2bCustomer {
  id
  accessBlocked
  applicantRole
  billingAddress {
    ...AddressFull
  }
  company {
    ...CompanyFull
  }
  companyName
  contactAddress {
    ...AddressFull
  }
  email
  enabledDeliveryTypes
  firstName
  gdprApprovedAt
  lastName
  paymentOnInvoiceEnabled
  phoneNumber
  presumedDeliveryInterval
  presumedDeliveryIntervalSpecified
  presumedOrderAmount
  presumedOrderAmountSpecified
  rejectionReason
  priceLevel
  shippingAddress {
    ...AddressFull
  }
  status
  tenantId
  fakturoidSubjectId
  note
  cognitoUsername
  deliveryPriceWithTax
  freeDeliveryFrom
  ...TimestampsFull
  ...SearchIndexFull
}
